import { render, staticRenderFns } from "./PracticeAdmin.vue?vue&type=template&id=db4340f6"
import script from "./PracticeAdmin.vue?vue&type=script&lang=js"
export * from "./PracticeAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports